module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/files/folder-check-e80121c71482ab2efcc8f8c9d8443ee7.svg";